import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const token = localStorage.getItem("token");
const userInfo = JSON.parse(localStorage.getItem("userInfo"));

export const getMemberOptions = async (query = "") => {
  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  try {
    let requestUrl =
      url.API_BASE_URL +
      url.API_GET_USERLIST_OPTIONS +
      `?token=${token}&userstringinput=${query}`;

    const response = await getData(requestUrl);

    if (response.status) {
      const apiData = response.data.map((item) => ({
        ...item,
        value: item.value,
        label: item.label,
      }));

      const userExists = apiData.some((item) => item.value === userObj.value);

      return userExists ? apiData : [...apiData, userObj];
    }
    return [userObj];
  } catch (error) {
    console.log(error.message);
    return [];
  }
};
